<template>
    <div>
        <UButton
            v-if="!hideButton && !visible"
            data-cy="new-account-entry-button"
            size="sm"
            class="mb-2"
            @click="showCreateNew"
        >
            Ny konto
        </UButton>
        <bookkeeping-account-editor
            v-if="visible && bookkeepingAccount"
            :bookkeeping-account="bookkeepingAccount"
            class="mb-4 p-4 rounded shadow bg-base-100  max-w-[120em]"
            @save="hide"
            @cancel="hide"
        />
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import BookkeepingAccountEditor from '@/bookkeeping-account/BookkeepingAccountEditor.vue'
import {defaultBookkeepingAccount} from '@/bookkeeping-account/bookkeepingAccount.service'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const visible = ref(false)
const bookkeepingAccount = ref<BookkeepingAccount>()

const emit = defineEmits(['hide-editor'])

defineProps({
    hideButton: {type: Boolean, default: false}
})

const show = (_bookkeepingAccount: BookkeepingAccount) => {
    bookkeepingAccount.value = _bookkeepingAccount
    visible.value = true
}

const showCreateNew = () => {
    show(defaultBookkeepingAccount())
}

const hide = () => {
    visible.value = false
}

emit('hide-editor', hide)

defineExpose({show})

</script>

<style>

</style>